/* eslint-disable */
import { Fragment } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import getDisplayDate from '../../../../utils/displayDate';
import CountdownTimer from '../../SharedComponents/CountdownTimer/CountdownTimer';
import * as classNames from './Pre.module.css';

function PreCopy({ openDate }) {
  return (
    <Fragment>
      <p className={classNames.psEmphasize}>
        {`Customization Will Open for You on ${getDisplayDate(openDate)}`}
      </p>
      <p className={classNames.psSummary}>
        This is where you’ll see your box customizations after you’ve selected them.
      </p>
    </Fragment>
  );
}

PreCopy.propTypes = {
  openDate: PropTypes.string.isRequired,
};

function Pre({ openDate, isMobile, timerRefresh }) {
  return (
    <div
      className={cx(classNames.preState, {
        [classNames.mobile]: isMobile,
      })}
    >
      <CountdownTimer openDate={openDate} timerRefresh={timerRefresh} />
      <PreCopy openDate={openDate} />
    </div>
  );
}

Pre.propTypes = {
  openDate: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  timerRefresh: PropTypes.func.isRequired,
};

export default Pre;
